import { useState } from "react";
import { useLanguage } from "@/i18n";
import { Menu, X, Flame } from "lucide-react";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const { t, lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const links = [
    { id: "journey", label: t.nav.experience },
    { id: "included", label: t.nav.included },
    { id: "menu", label: t.nav.menu },
    { id: "bar", label: t.nav.bar },
    { id: "practical", label: t.nav.practical },
  ];
  const langs = ["nl", "en", "es", "pap"];

  return (
    <header data-testid="navigation-bar" className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-stroke/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
        <button onClick={() => scrollToId("hero")} className="flex items-center gap-3 shrink-0" data-testid="nav-logo">
          <img src="/assets/logo.webp" alt="Curaçao Beach Barbecue" className="w-12 h-12 rounded-full ring-2 ring-sunset/60 object-cover shadow-[0_0_20px_rgba(255,94,26,0.35)]" />
          <span className="block font-display font-bold tracking-tight text-base leading-tight">
            CURAÇAO <span className="text-sunset">BEACH</span> BBQ
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <button key={l.id} onClick={() => scrollToId(l.id)} data-testid={`nav-link-${l.id}`}
              className="text-sm text-slate-300 hover:text-sunset transition-colors duration-300">
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="flex items-center rounded-full border border-stroke bg-surface/60 p-0.5">
            {langs.map((l) => (
              <button key={l} onClick={() => setLang(l)} data-testid={`language-switcher-${l}`}
                className={`px-2.5 py-1 rounded-full text-[11px] font-mono uppercase tracking-wider transition-colors duration-300 ${lang === l ? "bg-sunset text-night font-bold" : "text-slate-400 hover:text-slate-100"}`}>
                {l}
              </button>
            ))}
          </div>
          <button onClick={() => scrollToId("booking")} data-testid="nav-book-now-button"
            className="hidden sm:flex items-center gap-2 bg-sunset text-night font-semibold text-sm px-4 py-2 rounded-full hover:bg-flame transition-colors duration-300">
            <Flame size={15} /> {t.nav.book}
          </button>
          <button className="md:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-stroke/60 bg-night/95 backdrop-blur-xl px-5 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <button key={l.id} onClick={() => { scrollToId(l.id); setOpen(false); }}
              className="text-left text-slate-200 py-1.5 text-sm">
              {l.label}
            </button>
          ))}
          <button onClick={() => { scrollToId("booking"); setOpen(false); }}
            className="mt-1 flex items-center justify-center gap-2 bg-sunset text-night font-semibold text-sm px-4 py-2.5 rounded-full">
            <Flame size={15} /> {t.nav.book}
          </button>
        </div>
      )}
    </header>
  );
}
